/**
 * VENDOR MODULES
 */
import React from 'react';
import { useTranslation } from "react-i18next";

import { isFalsy }       from 'shared/utils/common';
import { isRacingSport } from 'shared/utils/markets';

import RacingArea        from 'features/markets/components/bets-area/RacingArea';
import BaseballArea      from 'features/markets/components/bets-area/BaseballArea';
import Football3dArea    from 'features/markets/components/bets-area/Football3dArea';

import { useMarketTypeGroupsQuery } from 'features/markets/queries';
import { filterAllowedMarketTypes, getAvailableMarketTypeIDS } from 'shared/utils/markets';
import { RtpTransparencyModal } from 'features/rtp/components/RtpTransparencyModal';

/***/
function BetsArea(props) {
  const { t } = useTranslation();
  const event = props;
  const {
      sport_id = 0,
      event_id = 0,
      batter_name = '',
      description = '',
      n_runners,
  } = event;
  const { data: market_type_groups = [] } = useMarketTypeGroupsQuery();
  const [isRtpOpen, setIsRtpOpen] = React.useState(false);

  // only render valid event
  if (!event_id || isFalsy(market_type_groups) || !Array.isArray(market_type_groups) || market_type_groups.length === 0) {
    return (<></>);
  }

  const market_types = market_type_groups.filter(x => parseInt(x.sport_id) == parseInt(sport_id));
  const available_market_types = filterAllowedMarketTypes(
      market_types,
      getAvailableMarketTypeIDS(event.markets)
  );
  const available_market_groups = available_market_types.map(x => parseInt(x.market_type_group_id));

  const isRacing = isRacingSport(sport_id);
  const isBaseball = sport_id == 40;
  const hideHeaderRow = isRacing || isBaseball;

  return (
    <div className="bets-area flex flex-col w-full">
      {!hideHeaderRow && (
        <div
          className="bets-area-head p-3 border-b border-border c7-sport-gradient"
          style={{ borderLeft: '4px solid var(--sport-color)' }}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex flex-wrap items-center gap-2 text-sm min-w-0 text-[var(--sport-on-color)]">
              <span className="bets-for-label font-semibold">{t('BETS_FOR')}</span>
              <span className="bets-event-id font-bold">#{event_id}</span>
              <span className="opacity-70">•</span>
              <span className="bets-event-description break-words min-w-0 flex-1 text-[var(--sport-on-color)]/80">
                {sport_id == 40 && (event.batter_name ?? '')}
                {sport_id == 50 && description}
                {isRacing &&
                  t('RACE_WITH', {n_runners: n_runners, sport: t('SPORT_'+ sport_id)})
                }
              </span>
            </div>

            <button
              type="button"
              onClick={() => setIsRtpOpen(true)}
              className="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-md bg-black/10 hover:bg-black/15 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--sport-color)] focus-visible:ring-offset-2 focus-visible:ring-offset-background text-[var(--sport-color)]"
              aria-label={t('RTP_TRANSPARENCY_TITLE') || 'Winning probability (RTP)'}
              title={t('RTP_TRANSPARENCY_TITLE') || 'Winning probability (RTP)'}
            >
              <i className="bi bi-info-circle text-lg" aria-hidden="true" />
            </button>
            <RtpTransparencyModal
              open={isRtpOpen}
              onClose={() => setIsRtpOpen(false)}
              scheduleId={event?.schedule_id}
              sportId={sport_id}
            />
          </div>
        </div>
      )}
      {isRacing &&
        <RacingArea
          available_market_groups={available_market_groups}
          event={event}
        />
      }

      {sport_id == 40 &&
        <BaseballArea
          available_market_groups={available_market_groups}
          event={event}
        />
      }

      {sport_id == 50 &&
        <Football3dArea
          available_market_groups={available_market_groups}
          event={event}
        />
      }
    </div>
  );
}

export default BetsArea;

